export default "__VITE_ASSET__BwNAU1dR__"